import React from 'react'
import clsx from 'clsx'
import styles from './Spinner.module.scss'

export interface SpinnerProps {
    className?: string
}

export const Spinner = ({
    className = '',
}: SpinnerProps) => (
    <div
        className={clsx(styles.spinner, className)}
    />
)
